import { Tooltip } from "@dialogueconsulting/sked-ui";
import { SaveAction } from "../../../components/Posts/PostForm/types";
import { PostStatesType } from "../../../constants/PostsView";
import { capitalize } from "lodash";
import { Button } from "../../../components/ui/button";
import { hotkeyManager } from "../../../ui/SkedCaption/hot-key-manager";
import { ShortcutKey } from "../../../ui/shortcut-key";

export const PostSaveButton = ({
  disabled,
  onSave,
  postState,
  isPostNow,
}: {
  disabled?: boolean;
  onSave?: (action: SaveAction) => void;
  postState: PostStatesType;
  isPostNow: boolean;
}) => {
  return (
    <Tooltip
      hideArrow
      contentBackgroundStyle={{
        backgroundColor: "white",
        borderRadius: "8px",
        color: "black",
      }}
      text={
        <div className="flex flex-col gap-[8px] text-[8px] text-neutral-800 leading-[12px]">
          <div className="flex gap-[4px] align-center">
            {hotkeyManager.isMac() ? (
              <ShortcutKey>
                <i className="fa fa-command text-neutral-800" />
              </ShortcutKey>
            ) : (
              <ShortcutKey>
                <span>Ctrl</span>
              </ShortcutKey>
            )}
            <ShortcutKey>
              <span>Enter</span>
            </ShortcutKey>
            to {resolvePostStateSaveLabel(postState, false)} post
          </div>
        </div>
      }
      side="bottom"
    >
      <div>
        <Button
          onClick={() => onSave?.("save-and-show-success-screen")}
          disabled={disabled}
          size="lg"
          variant="blue-primary"
        >
          {capitalize(resolvePostStateSaveLabel(postState, isPostNow))}
        </Button>
      </div>
    </Tooltip>
  );
};

function resolvePostStateSaveLabel(
  postState: PostStatesType,
  isPostNow: boolean
): string {
  switch (postState) {
    case "DRAFT": {
      return "save";
    }
    case "SCHEDULED": {
      if (isPostNow) {
        return "post now";
      }
      return "schedule";
    }
    case "QUEUED": {
      return "queue";
    }
  }
  return "save";
}
